export default "__VITE_ASSET__CRPuHODJ__"